export enum FundraisingCampaignStatus {
  NOT_PUBLISHED = 'NOT_PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  PUBLISHED = 'PUBLISHED',
  ENDED = 'ENDED',
}

export type FundraisingCampaign = {
  id: string;
  created_at: string;
  title: string;
  description: string;
  goal: number;
  collected?: number;
  pix_key: string;
  status: FundraisingCampaignStatus;
  start_at?: string;
  end_at?: string;
  image?: string;
  is_draft?: boolean;
};

export type FundraisingCampaignJustifyExpenses = {
  id: string;
  campaign_name: string;
  collected_value: number;
  thank_you_message?: string;
  total_expenses: number;
  expenses_details: Array<{
    title: string;
    value: number;
    receipt_url: string;
  }>;
};
